import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    ActiveUserPipe,
    PersonPipe,
    FormControlPipe,
    FullNamePipe,
    UserDetailPipe,
    UserPhotoPipe,
} from './common.pipe';

@NgModule({
    imports: [],
    declarations: [
        ActiveUserPipe,
        PersonPipe,
        FormControlPipe,
        FullNamePipe,
        UserDetailPipe,
        UserPhotoPipe,
    ],
    exports: [
        ActiveUserPipe,
        PersonPipe,
        FormControlPipe,
        FullNamePipe,
        UserDetailPipe,
        UserPhotoPipe,
    ],
    providers: [
    ]

})
export class PipesModule { }
